import { Component } from '@angular/core';

@Component({
  selector: 'app-landing-links',
  templateUrl: './landing-links.component.html',
  styleUrls: ['./landing-links.component.scss']
})
export class LandingLinksComponent {

}
